module.exports = __webpack_public_path__ + "img/button-message.ac156bce.svg";